import React from "react";
import ReactDOM from "react-dom/client";
import reportWebVitals from "./reportWebVitals";
import "./Styles/main.scss";

import {
  Routes,
  BrowserRouter as Router,
  Route,
  Navigate,
} from "react-router-dom";
import Login from "./Components/Login";
import Dashboard from "./Components/Dashboard";
import Intro from "./Components/Intro";
import Game from "./Components/Game";
import Outro from "./Components/Outro";
import { Rights } from "./Components/Rights";
const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <Router>
    <Routes>
      <Route path="/login" element={<Login />}></Route>
      <Route path="/intro" element={<Intro />}></Route>
      <Route path="/game" element={<Game />}></Route>
      <Route path="/rights" element={<Rights />}></Route>
      <Route path="/ending" element={<Outro />}></Route>
      <Route path="/dashboard" element={<Dashboard />}></Route>
      <Route path="*" element={<Navigate to={"/intro"} />} />
    </Routes>
  </Router>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
